import { useState } from 'react';
import { useAuth, authFetch } from '../contexts/AuthContext';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Mail, Loader2, CheckCircle2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function EmailVerificationWall() {
  const { user } = useAuth();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      await authFetch(`${API_URL}/api/auth/resend-verification`, { method: 'POST' });
      setResent(true);
    } catch { /* non-blocking */ }
    setResending(false);
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="email-verification-wall">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-8 text-center space-y-4">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto">
            <Mail className="w-8 h-8 text-amber-600" />
          </div>
          <h2 className="text-xl font-bold text-[#0F172A]">Confirma tu correo electrónico</h2>
          <p className="text-sm text-muted-foreground">
            Enviamos un enlace de verificación a <strong>{user.email}</strong>. Haz clic en el enlace para activar tu cuenta y acceder a las herramientas.
          </p>
          {resent ? (
            <div className="flex items-center justify-center gap-2 text-sm text-green-600">
              <CheckCircle2 className="w-4 h-4" />
              <span>Correo reenviado</span>
            </div>
          ) : (
            <Button variant="outline" size="sm" onClick={handleResend} disabled={resending} data-testid="resend-verification-btn">
              {resending ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
              Reenviar correo de verificación
            </Button>
          )}
          <p className="text-xs text-muted-foreground">Revisa tu bandeja de spam si no lo encuentras.</p>
        </CardContent>
      </Card>
    </div>
  );
}
